export const QueryTags = {
  ACLPermissions: 'ACLPermissions',
  Book: 'Book',
  Company: 'Company',
  Department: 'Department',
  DepartmentList: 'DepartmentList',
  DocumentAccessibility: 'DocumentAccessibility',
  DocumentBookGroups: 'DocumentBookGroups',
  FileQuery: 'FileQuery',
  HistoryLogList: 'HistoryLogList',
  InternalDocumentComments: 'InternalDocumentComments',
  InternalDocumentDetail: 'InternalDocumentDetail',
  IncomingInternalDocumentList: 'IncomingInternalDocumentList',
  OutgoingInternalDocumentList: 'OutgoingInternalDocumentList',
  IssuingAuthority: 'IssuingAuthority',
  ModuleQuery: 'ModuleQuery',
  NotiPermission: 'NotiPermission',
  Position: 'Position',
  UserAccounts: 'UserAccounts',
  UserDetail: 'UserDetail',
  UserCreditLimit: 'UserCreditLimit',
  UserModuleQuery: 'UserModuleQuery',
  UserTransactions: 'UserTransactions',
  ViewLogList: 'ViewLogList',
  VoteList: 'VoteList',
  WorkComments: 'WorkComments',
  WorkDetail: 'WorkDetail',
  WorkList: 'WorkList',
  WorkSchedule: 'WorkSchedule',
  WorkScheduleManagement: 'WorkScheduleManagement',
};
